export enum BenefitFilterValuesEnum {
    All = "All",
    Enrolled = "Enrolled",
    Pending = "Pending",
    Available = "Available",
    MyEvents = "MyEvents",
    Invited = "Invited",
    Joined = "Joined"
}